// extracted by mini-css-extract-plugin
module.exports = {"round":"CheckBox_round__3J8pN"};